<script>
export default {
    name: 'BaseTimePickerAmPm',
};
</script>

<script setup>
import { computed } from 'vue';
import { TYPE } from '@/components/base-components/components/time-picker/index.js';
import BaseTimePickerPicker from '@/components/base-components/components/time-picker/components/picker.vue';

const props = defineProps({
    value: {
        type: Date,
    },
    type:  {
        type:      String,
        default:   TYPE.DEFAULT,
        validator: value => Object.values(TYPE).includes(value),
    },
});

const emit = defineEmits({
    input: null,
});

const options = [
    {
        value: 'AM',
        label: 'AM',
    },
    {
        value: 'PM',
        label: 'PM',
    },
];

const model = computed({
    get: () => (props.value ?? new Date()).getHours() < 12 ? 0 : 1,
    set: (value) => {
        const date = new Date(props.value ?? new Date());

        let hours = date.getHours();

        if (value === 0 && hours >= 12) {
            hours -= 12;
        } else if (value === 1 && hours < 12) {
            hours += 12;
        }

        date.setHours(hours);

        emit('input', date);
    },
});
</script>

<template>
    <base-time-picker-picker
        v-model="model"
        :items="options"
        :type="type"
    />
</template>
